import { render, staticRenderFns } from "./ReportDownloadsTable.vue?vue&type=template&id=15c9c376&"
import script from "./ReportDownloadsTable.vue?vue&type=script&lang=js&"
export * from "./ReportDownloadsTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportDownloadsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports